import { fetchAPI } from "@/api/api"
import { FilterContext } from "@/types/queryInitInfo"

const URL = "/exchange/member/playerService/queryEventLabel"

export type Payload = {
  isMobile: boolean
}

export type Response = {
  eventLabel: FilterContext[]
  status: string
  status_msg: string
}

const fetch = {
  url: URL,
  handler: async ({ payload }: { payload: Payload }) => {
    try {
      const { isMobile } = payload

      const res: Response = await fetchAPI({
        url: URL,
        method: "post",
        withCredentials: true,
        pageName: "",
        data: {
          isMobile: isMobile ? 1 : 0
        },
        hasStatus: true
      })

      return Promise.resolve(res.eventLabel)
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default fetch
